import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { PUBLIC_SITE_ORIGIN } from "@/lib/public-origin";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/")({
  component: lazyRouteComponent(() => import("./-pages/account.index")),
  head: () => ({
    meta: [
      { title: DICTS.en["account.meta.title"] },
      { name: "description", content: DICTS.en["account.meta.description"] },
      { property: "og:title", content: DICTS.en["account.meta.title"] },
      { property: "og:description", content: DICTS.en["account.meta.description"] },
      { property: "og:image", content: `${PUBLIC_SITE_ORIGIN}/og/account.jpg` },
      { property: "og:image:width", content: "1216" },
      { property: "og:image:height", content: "640" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: `${PUBLIC_SITE_ORIGIN}/og/account.jpg` },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
